import type {
  ReliabilityScoreInfluence,
  ReliabilityScoreInfluenceDirection,
} from '../generated/gql-types';
import { getApolloClient } from '../lib/getApolloClient';
import { handleGraphQLErrors } from '../util/graphqlError.util';
import {
  CONVERT_JOB_INFLUENCE_DIRECTION,
  EXCLUDE_JOB_FROM_RELIABILITY_SCORE,
  JOBS_CONTRIBUTING_TO_RELIABILITY_SCORE,
} from './reliabilityScore.gql';

export const fetchJobsContributingToReliabilityScore = async (
  userId: string,
  directions?: ReliabilityScoreInfluenceDirection[],
): Promise<ReliabilityScoreInfluence[]> => {
  const response = await getApolloClient().query({
    query: JOBS_CONTRIBUTING_TO_RELIABILITY_SCORE,
    variables: { userId, directions },
    fetchPolicy: 'network-only',
  });

  handleGraphQLErrors(
    response.errors,
    'Failed to fetch jobs contributing to reliability score',
  );

  return response.data?.jobsContributingToReliabilityScore ?? [];
};

export const excludeJobFromReliabilityScore = async (
  jobId: string,
  reason?: string,
): Promise<boolean> => {
  const response = await getApolloClient().mutate({
    mutation: EXCLUDE_JOB_FROM_RELIABILITY_SCORE,
    variables: { jobId, reason },
  });

  handleGraphQLErrors(
    response.errors,
    'Failed to exempt job from reliability score',
  );

  return response.data?.excludeJobFromReliabilityScore ?? false;
};

export const convertJobInfluenceDirection = async (
  jobId: string,
  userId: string,
): Promise<ReliabilityScoreInfluence> => {
  const response = await getApolloClient().mutate({
    mutation: CONVERT_JOB_INFLUENCE_DIRECTION,
    variables: { jobId, userId },
  });

  handleGraphQLErrors(
    response.errors,
    'Failed to update reliability score exemption',
  );

  if (!response.data?.convertJobInfluenceDirection) {
    throw new Error('Failed to update reliability score exemption');
  }

  return response.data.convertJobInfluenceDirection;
};

export const reliabilityScoreActions = {
  fetchJobsContributingToReliabilityScore,
  excludeJobFromReliabilityScore,
  convertJobInfluenceDirection,
};
